module.exports = __webpack_public_path__ + "static/reg-large4-c34756786a1d81732523fcebb28fa78f.jpg";